import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function ChangePhoneModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Change Phone Number</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Current Phone Number</Form.Label>
          <Form.Control placeholder="Enter Phone Number" />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>New Phone Number *</Form.Label>
          <Form.Control placeholder="Enter Phone Number" />
        </Form.Group>

        <Form.Group>
          <Form.Label>Confirm Password *</Form.Label>
          <Form.Control type="password" />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light">Cancel</Button>
        <Button className="dark-btn">Change Number</Button>
      </Modal.Footer>
    </Modal>
  );
}